import axios from 'axios';
import { apiHost } from '../../../utils/apiHost';

export const getApiBaseUrl = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  const baseUrl = apiHost().replace(/^https?:\/\//, '');
  return `${protocol}://${baseUrl}`;
};

export const fetcher = async (url) => {
  const response = await axios.get(url, { withCredentials: true });
  return response.data;
};

export async function fetchProductsAndCategories() {
  const [productResponse, categoryResponse] = await Promise.all([
    axios.get(`${getApiBaseUrl()}/barangcabang`, { withCredentials: true }),
    axios.get(`${getApiBaseUrl()}/kategori`, { withCredentials: true }),
  ]);
  return {
    products: productResponse.data.data || [],
    categories: categoryResponse.data.data || [],
  };
}

export async function fetchMe() {
  const response = await axios.get(`${getApiBaseUrl()}/me`, { withCredentials: true });
  return response.data;
}

export async function fetchCustomers(search = '') {
  const response = await axios.get(`${getApiBaseUrl()}/getcustomerkasir?search=${encodeURIComponent(search)}`, {
    withCredentials: true,
  });
  return response.data?.data || [];
}

export async function fetchCustomerCategories() {
  const response = await axios.get(`${getApiBaseUrl()}/categorycustomer`, { withCredentials: true });
  return response.data?.data || [];
}

export async function createCustomer(payload) {
  const response = await axios.post(`${getApiBaseUrl()}/createcustomer`, payload, { withCredentials: true });
  return response.data?.data;
}

export async function fetchCabangConfig(cabangUuid) {
  const response = await axios.get(`${getApiBaseUrl()}/getkonfigurasicabang?cabangUuid=${cabangUuid}`, {
    withCredentials: true,
  });
  return response.data?.data || null;
}

export async function fetchPengaturanUtama() {
  try {
    const response = await axios.get(`${getApiBaseUrl()}/getpengaturanutama`, { withCredentials: true });
    return response.data?.data || null;
  } catch {
    return null;
  }
}

export async function fetchTables() {
  const response = await axios.get(`${getApiBaseUrl()}/getmeja`, { withCredentials: true });
  return Array.isArray(response.data?.data) ? response.data.data : [];
}

export async function fetchTakeaway() {
  const response = await axios.get(`${getApiBaseUrl()}/gettakeaway`, { withCredentials: true });
  return Array.isArray(response.data?.data) ? response.data.data : [];
}

export async function fetchNonCashMethods() {
  const response = await axios.get(`${getApiBaseUrl()}/getnoncashmethod`, { withCredentials: true });
  return Array.isArray(response.data?.data) ? response.data.data : [];
}

export async function createTransaksiCabang(payload) {
  return axios.post(`${getApiBaseUrl()}/createtransaksicabang`, payload, { withCredentials: true });
}

